var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsNotEmpty, IsOptional, IsString, IsUUID, MaxLength, MinLength, } from 'class-validator';
import { OfficeLocationStub } from '../../offices/index.js';
export class UpdateUserDto {
    id;
    currentOfficeLocationId;
    firstName;
    lastName;
    /** `null` clears the stored number — `undefined` would leave it untouched. */
    mobilePhone;
    registeredAt;
    agreedTermsConditions;
    agreedNewsletter;
    isArchived;
    therapistId;
    countryCode;
    krankenkasse;
    pkvInsurerName;
    pkvPolicyNumber;
    /** `null` clears the stored value — `undefined` would leave it untouched. */
    street;
    /** `null` clears the stored value — `undefined` would leave it untouched. */
    zip;
    /** `null` clears the stored value — `undefined` would leave it untouched. */
    town;
    salutation;
    therapyArea;
    /** `null` clears the stored date — `undefined` would leave it untouched. */
    birthdate;
    notes;
    allowedOfficeLocations;
    customFormId;
    customForms;
}
__decorate([
    IsOptional(),
    IsNotEmpty(),
    IsString(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "currentOfficeLocationId", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "firstName", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "lastName", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "mobilePhone", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "registeredAt", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateUserDto.prototype, "agreedTermsConditions", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateUserDto.prototype, "agreedNewsletter", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateUserDto.prototype, "isArchived", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "therapistId", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MinLength(2),
    MaxLength(3),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "countryCode", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "krankenkasse", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "pkvInsurerName", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "pkvPolicyNumber", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "street", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "zip", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "town", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "salutation", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "therapyArea", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "birthdate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateUserDto.prototype, "notes", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Type(() => OfficeLocationStub),
    __metadata("design:type", Array)
], UpdateUserDto.prototype, "allowedOfficeLocations", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateUserDto.prototype, "customFormId", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], UpdateUserDto.prototype, "customForms", void 0);
//# sourceMappingURL=update-user.dto.js.map